import React from 'react';

const Minus = ({ className, color }) => {
  return (
    <svg className={className} version="1.0" xmlns="http://www.w3.org/2000/svg" width="30" viewBox="0 0 546.000000 531.000000"  preserveAspectRatio="xMidYMid meet">  <g transform="translate(0.000000,531.000000) scale(0.100000,-0.100000)" fill={color ? color : '#000000'} stroke="none"> <path d="M230 2813 c-40 -8 -101 -63 -121 -111 -45 -104 0 -215 106 -263 38 -18 139 -19 2498 -19 2655 0 2486 -3 2554 50 50 39 67 79 67 156 -1 79 -18 111 -84 162 l-35 27 -2480 1 c-1364 1 -2491 -1 -2505 -3z"/> </g> </svg> 
  );
};

export default Minus;
